<template>
  <lu-vbox ifd="tags-view-container" class="tags-view-container">

    <!--<scroll-pane ref="scrollPane" class="tags-view-wrapper" v-if='needTagsView'>-->
    <lu-scroll-area class="tags-view-wrapper" v-if='needTagsView'>
      <lu-hbox lu-flex>
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="getKey(tag)"
          :class="isActive(tag)?'active':''"
          :to="getRoute(tag)"
          tag="span"
          class="tags-view-item"
          @click.left.prevent.native='navigate(tag)'
          @click.middle.native="closeSelectedTag(tag)"
          @contextmenu.prevent.native="openMenu(tag,$event)"
        >
          <span class='tag-title'>{{ tag.title }}</span>
          <span v-if="!tag.meta.affix" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
        </router-link>
      </lu-hbox>
    <!-- </scroll-pane> -->
    </lu-scroll-area>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">Refresh</li>
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">Close</li>
      <li @click="closeOthersTags">Close Others</li>
      <li @click="closeAllTags(selectedTag)">Close All</li>
    </ul>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox, LuScrollArea } from 'lusis-ui'
// import ScrollPane from './ScrollPane'
import path from 'path'
import { mapGetters, mapState } from 'vuex'

export default {
  components: { LuHbox, LuVbox, LuScrollArea },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    ...mapState({ needTagsView: state => state.settings.tagsView }),
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes || []
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.params && route.params.recordLabel && this.$route.params ? route.params.recordLabel == this.$route.params.recordLabel : route.path === this.$route.path
    },
    getKey(tag) {
      let key = tag.path
      if (tag.params && tag.params.recordId) key += tag.params.recordId
      return key
    },
    getRoute(tag) {
      if (!tag.params) return { path: tag.path, query: tag.query, fullPath: tag.fullPath }
      return {
        name: tag.name,
        params: tag.params,
        meta: tag.meta,
        title: tag.title
      }
    },
    navigate(tag) {
      let next = this.getRoute(tag)
      if ((next.path && next.path != this.$route.path) || (next.name && next.name != this.$route.name)) {
        this.$router.push(next)
      }
      else {
        this.$router.push(this.$route.path + '?next=' + new Date().toJSON()).then(() => this.$router.push(next))
      }
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (this.$route.params && !this.$route.params.__isValid && this.$route.meta && this.$route.meta.parent || this.$route.params.create) return false
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags) return
      this.$nextTick(() => {
        for (const tag of tags) {
          if ((tag.to.name === this.$route.name ||
               tag.to.path === this.$route.path) &&
               (!(tag.to.params && this.$route.params && tag.to.params.recordId && this.$route.params.recordId) ||
                 (tag.to.params.recordId === this.$route.params.recordId))) {
            // this.$refs.scrollPane.moveToTarget(tag)
            tag.$el.scrollIntoView()
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath || tag.to.params.recordLabel !== this.$route.params.recordLabel) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Home') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>

.tags-view-container {
  // width: 100%;
  // padding-bottom: 10px;
  //padding: 25px 10px 10px 0px;
  // box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  .tags-view-wrapper {
    height: 34px;
    margin-bottom: 5px;
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
      border-radius: 5px;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 0px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        border-radius: 5px;
        &::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 2px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    // box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {

      }
    }
  }

  .hamburger-container {
    float: left;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    white-space: nowrap;

    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
      }
    }
  }

  & .lu-scrollbar[orientation='horizontal'] {
    left: 0px;
    bottom: -5px;
  }
}
</style>
